import type { FaireProductEntity } from "../../entity_types/product";

export const p_33s2zg23mv: FaireProductEntity = {
  token: "p_33s2zg23mv",
  type: "product",
  name: "Tiny Tomatoes",
  brandToken: "b_q8txr236ny",
  brandName: "Not Picasso",
  imageUrl:
    "https://cdn.faire.com/fastly/177edb1a3776830c500eb136ed121f64202f2f7f2ca956de4b9e95046d1c1ba9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6dfd3173e6a293e34d83450fd6703c086abf0f5b17c7176252126cfc6f10cf83.jpeg",
    "https://cdn.faire.com/fastly/300b60dbcc4bc584d3fced6dbbf0a8fa830d1971e425a83fac1486cbe7ffba18.jpeg",
    "https://cdn.faire.com/fastly/fd68f1366971b46389a10d436a852143eacfcecba7eee734651d4b7070e899bb.jpeg",
    "https://cdn.faire.com/fastly/630ecdc7d506403e7d40d8d23fb771e99b67df16184bdf4d76427eae13e66928.jpeg",
    "https://cdn.faire.com/fastly/84f201ee2e5c0edfd91461fe71636d42b744a87eb6e1d6f7928115555b3248e1.jpeg",
  ],
  priceDollars: 8,
  description:
    'Mini tomato’s for your ears!\n\nMade from an original design and laser-cut acrylic. Each piece is handmade, so slight differences can be expected. These are finished with hypoallergenic, anti-tarnish gold-plated stainless steel hoop. Earrings arrive set on a Not Picasso branded display card.* (2” x 2”)\n\n*Display card may be switched to a branded large card (5.5” x 4.2") by request.',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:16.356Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
